// Feature flags read from Vite env vars. All default to false / disabled.
// Flip in .env.local or deployment env when a feature is ready to enable.

// SPEC-multiproject-bill-split.md — one upload → many project bills. Live for
// the Shopping-List checkout caller (MobileProcurementPage) as of Stage 3;
// defaults true now that a real caller wires it end-to-end.
export function useBillSplitEnabled(): boolean {
  return ((import.meta as any).env?.VITE_BILL_SPLIT_ENABLED ?? 'true') === 'true'
}

export function useTaskViewHubEnabled(): boolean {
  return ((import.meta as any).env?.VITE_TASK_VIEW_HUB_ENABLED ?? 'false') === 'true'
}

export function useSageCommsEnabled(): boolean {
  return ((import.meta as any).env?.VITE_SAGE_COMMS_ENABLED ?? 'false') === 'true'
}

// SPEC-LOCATION-KIOSK-REFRESH (#437) — Big-Board redesign of the location kiosk.
// While disabled the existing LocationKioskPage continues to render. When the
// flag flips on, the new KioskBigBoardPage renders instead. P5 of the epic
// removes the legacy page entirely.
export function useKioskBigBoardEnabled(): boolean {
  // P5 note: flag defaults true — legacy LocationKioskPage removed in P5 (#444).
  return ((import.meta as any).env?.VITE_KIOSK_BIGBOARD_ENABLED ?? 'true') === 'true'
}
